import { useRecoilValue } from 'recoil';
import { drawerV2Atom } from '../stores/atom';
import { useDrawerV2 } from '../hooks/useDrawerV2';
import { Drawer, Stack } from '@mui/material';
import { DrawerV2Inputs } from '../types/drawerV2';
import { TextBlock } from 'common/ui/TextBlock';

const DrawerV2Content: React.FC<{
  inputs: DrawerV2Inputs;
}> = ({ inputs }) => {
  return (
    <Stack
      sx={{
        p: '32px',
        height: '100%',
        boxSizing: 'border-box',
        minHeight: 0
      }}
    >
      <TextBlock
        variant="drawer"
        title={inputs.title}
        subtitle={inputs.subtitle}
      />
      <Stack sx={{ flex: 1, minHeight: 0 }}>{inputs.children}</Stack>
    </Stack>
  );
};

export const DrawerV2 = () => {
  const drawerV2 = useRecoilValue(drawerV2Atom);
  const { closeDrawer } = useDrawerV2();

  const { isOpen, inputs, preventClose } = drawerV2;

  return (
    <Drawer
      open={isOpen}
      anchor="right"
      onClose={() => {
        // Ignore backdrop-click / Escape while the drawer has work in flight,
        // so its requests aren't abandoned mid-way.
        if (preventClose) {
          return;
        }
        closeDrawer();
      }}
      sx={{ zIndex: 1400 }}
      PaperProps={{
        sx: {
          width: inputs?.width ?? '380px',
          height: '100%',
          maxHeight: '100vh',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      {inputs && <DrawerV2Content inputs={inputs} />}
    </Drawer>
  );
};
